import { i18n } from 'i18n';

export const STATS_UPDATES = () => ({
	auto_welding: i18n.t('Автосверка'),
	manual: i18n.t('Ручное'),
});
